import auth0 from 'auth0-js';

export interface IAuth0Config {
  auth0clientID: string; // The auth0 application client id. Required for auth0 setup
  auth0domain: string; // The login domain. Required for auth0 setup
  auth0callbackUrl: string; // Configured auth0 callback URL. Required for auth0 setup
}

export const getAuthToken = async (auth0config: IAuth0Config) => {
  return new Promise((resolve, reject) => {
    const webAuth = new auth0.WebAuth({
      domain: auth0config.auth0domain,
      clientID: auth0config.auth0clientID,
      responseType: 'token',
      scope: 'openid profile email'
    });
    webAuth.checkSession(
      {
        responseType: 'token',
        redirectUri: auth0config.auth0callbackUrl
      },
      (err, authResult) => {
        if (err) {
          return reject(err);
        }
        if (authResult && authResult.accessToken) {
          return resolve(authResult.accessToken);
        }
        return reject('No auth0 token present in response');
      }
    );
  });
};
